import axios from 'axios';

export const fetchDestinationHierarchy = async (destinationId) => {
  const destinationResponse = await axios.get(`https://aaryanholidays.in/backend/destinations/${destinationId}`);
  const destination = destinationResponse.data;

  const tourTypeResponse = await axios.get(`https://aaryanholidays.in/backend/tour-types/${destination.tour_type_id}`);
  const tourType = tourTypeResponse.data;

  const continentResponse = await axios.get(`https://aaryanholidays.in/backend/continents/${tourType.continent}`);
  const continent = continentResponse.data;

  return {
    destinationId,
    destinationName: destination.thumbnail_heading,
    tourTypeId: destination.tour_type_id,
    tourTypeName: tourType.tour_type,
    continentId: tourType.continent,
    continentName: continent.continent
  };
};
